<template>
  <router-link to="/" class="logo-link">
    <div class="logo-container">
      <img
      src="https://img.icons8.com/?size=100&id=108378&format=png&color=10b981"
      alt="Ready Set Spray Logo"
      class="logo-image"
      />

      <svg viewBox="0 0 300 80" xmlns="http://www.w3.org/2000/svg" class="logo-svg">
        <defs>
          <!-- Brand gradient -->
          <linearGradient id="brandGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color:#10b981" />
          <stop offset="100%" style="stop-color:#0e9669" />
          </linearGradient>
      
          <!-- Subtle glow for spider -->
          <filter id="subtleGlow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
          </filter>
        </defs>
        
        <!-- Clean typography with periods - dark mode friendly -->
        <text x="20" y="50" 
            font-family="system-ui, -apple-system, sans-serif" 
            font-size="32" 
            font-weight="700" 
            letter-spacing="-0.5px"
            fill="#9ca3af">Ready</text>
            
        <text x="117" y="50" 
            font-family="system-ui, -apple-system, sans-serif" 
            font-size="32" 
            font-weight="800" 
            letter-spacing="-0.5px"
            fill="#64748b">Set</text>
            
        <text x="175" y="50" 
            font-family="system-ui, -apple-system, sans-serif" 
            font-size="32" 
            font-weight="900" 
            letter-spacing="-0.5px"
            fill="url(#brandGradient)"
            filter="url(#glow)">Spray.
          <animate attributeName="opacity" values="0.7;1;0.7" dur="2s" repeatCount="indefinite"/>
        </text>
      </svg>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'ReadySetSprayLogo'
}
</script>

<style scoped>
.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  padding-left: 0;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo-svg {
  height: 50px;
  width: auto;
  transition: all 0.3s ease;
  cursor: pointer;
  overflow: visible;
}

@media (prefers-reduced-motion: reduce) {
  .logo-svg {
    transition: none;
  }
  
  .logo-svg :deep(animate),
  .logo-svg :deep(animateTransform) {
    animation: none !important;
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.logo-image {
  height: 40px;
  width: auto;
  transition: all 0.3s ease;
  cursor: pointer;
  animation: bounce 2s infinite ease-in-out;
  padding: 0.25rem 0;
}

.logo-image:hover {
  transform: scale(1.05);
  filter: brightness(1.1);
}
</style>